module.exports = {"apiUrl":"https://tiger.prod.qortex.ru"};